import { animateBeforeAfterPanelStats } from './before-after-stats-animation.js';

/**
 * @param {HTMLElement} section
 */
export function initBeforeAfterCategoryTabs(section) {
	const tablist = section.querySelector('.before-after__tabs');
	const panels = section.querySelectorAll('.before-after__category-panel');

	if (!tablist || !panels.length) {
		return;
	}

	const tabs = tablist.querySelectorAll('.before-after__tab');

	// Slide copy (title/text) lives on the carousel item and is mirrored onto the
	// panel; the section header shows the active slide's copy.
	const titleEl = section.querySelector('.js-before-after-title');
	const textEl = section.querySelector('.js-before-after-text');

	const applySlideCopy = (panel) => {
		const title = panel.dataset.slideTitle;
		const text = panel.dataset.slideText;

		if (titleEl && title) {
			titleEl.textContent = title;
		}
		if (textEl && text) {
			textEl.textContent = text;
		}
	};

	let activeIndex = 0;

	const activatePanel = (index) => {
		const indexStr = String(index);
		activeIndex = Number(index);

		tabs.forEach((tab) => {
			const isActive = tab.dataset.categoryIndex === indexStr;
			tab.classList.toggle('is-active', isActive);
			tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});

		panels.forEach((panel) => {
			const isActive = panel.dataset.categoryPanel === indexStr;

			panel.classList.toggle('is-active', isActive);
			panel.hidden = !isActive;

			if (isActive) {
				applySlideCopy(panel);

				const activeStats = panel.querySelector('.before-after__stats-pair-slide.is-active') ?? panel;
				delete activeStats.dataset.statsAnimated;
				animateBeforeAfterPanelStats(activeStats, { force: true });
			}
		});
	};

	tabs.forEach((tab) => {
		tab.addEventListener('click', () => {
			activatePanel(tab.dataset.categoryIndex);
		});
	});

	// Prev/next arrows page through the categories (one slide each) when the
	// category has no multi-pair carousel of its own.
	if (panels.length > 1) {
		section.querySelectorAll('.js-before-after-slide-nav').forEach((nav) => {
			const panel = nav.closest('.before-after__category-panel');
			const pairSlides = panel
				? panel.querySelectorAll('.before-after__chart-pair-slide')
				: [];

			if (pairSlides.length > 1) {
				return; // pair carousel owns these buttons
			}

			nav.querySelectorAll('.before-after__stats-btn').forEach((btn) => {
				const step = btn.classList.contains('before-after__stats-btn--prev') ? -1 : 1;

				btn.addEventListener('click', () => {
					const next = (activeIndex + step + panels.length) % panels.length;
					activatePanel(next);
				});
			});
		});
	}
}

export function initBeforeAfterSections() {
	document.querySelectorAll('.js-before-after-section').forEach((section) => {
		initBeforeAfterCategoryTabs(section);
	});
}
